import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import Subtext from './text/Subtext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTile = styled(UITile).withConfig({
  displayName: "FreeUsersDisclaimer__StyledTile",
  componentId: "sc-1f04fh0-0"
})(["margin-top:24px;font-size:12px;text-align:center;padding:8px;"]);
export const FreeUsersDisclaimer = () => /*#__PURE__*/_jsxs(StyledTile, {
  children: [/*#__PURE__*/_jsx("b", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.seatsPicker.unlimitedFreeUsers.title"
    })
  }), /*#__PURE__*/_jsx(Subtext, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      className: "m-left-1",
      message: "pricingPage.seatsPicker.unlimitedFreeUsers.text"
    })
  })]
});